import jump from "jump.js";
import Gator from "gator";

Gator(document.documentElement).on("click", ".arrow_down", function() {
    let nextNode = this.parentNode.nextElementSibling;
    if (nextNode) {
        jump(nextNode, {
            offset: -55
        });
    }
    else {
        jump('footer', {
        });
    }
});
// if(navigator.userAgent.match(/Trident\/7\./)) {
//     Gator(body).on("mousewheel", function () {
//         // remove default behavior
//         event.preventDefault();
//
//         //scroll without smoothing
//         var wheelDelta = event.wheelDelta;
//         var currentScrollPosition = window.pageYOffset;
//         window.scrollTo(0, currentScrollPosition - wheelDelta);
//     });
// }
